import React from 'react';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Heading from '@interness/web-core/src/components/text/Heading/Heading';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Error = () => {
  return ___EmotionJSX(Wrapper, null, ___EmotionJSX(Spacer, null), ___EmotionJSX(Heading, null, "Fehler"), ___EmotionJSX("p", null, "Bitte versuchen Sie es sp\xE4ter erneut."), ___EmotionJSX(Link, {
    to: '/'
  }, "Zur\xFCck nach Hause"));
};
export default Error;